import { NgModule } from '@angular/core';
import { HasAccessPipe } from './has-access.pipe';
import { HasAccessAsyncPipe } from './has-access-async.pipe';

@NgModule({
    declarations: [HasAccessPipe, HasAccessAsyncPipe],
    exports: [HasAccessPipe, HasAccessAsyncPipe],
})
export class HasAccessPipeModule {}
